import React from 'react';
import { Text } from '@cotera/client/app/components/ui';

/**
 * Label + optional hint above a control, so every block in every node editor
 * reads the same.
 *
 * Lifted out of the debounce editor once the bucket editor needed it. The two
 * had drifted apart on nothing but spacing — `gap-1.5` against `gap-2`, a
 * `font-medium` label against a plain one — which is the kind of difference
 * nobody can name but everybody can see when the drawer switches nodes.
 */
export const Field: React.FC<{
  label: string;
  hint?: React.ReactNode;
  children: React.ReactNode;
}> = ({ label, hint, children }) => (
  <div className="flex flex-col gap-1.5">
    <Text.Caption className="text-muted-foreground block font-medium">
      {label}
    </Text.Caption>
    {hint !== undefined ? (
      <Text.Caption className="text-muted-foreground/80 block">
        {hint}
      </Text.Caption>
    ) : null}
    {children}
  </div>
);
